import { ADD_FIELD } from "./actionsType";

export const addField = (field,field_value) => {
   return {
      type: ADD_FIELD,
      field: field,
      field_value: field_value
   }
}